export const sortPunchlistTodoItems = (arr: any[], key: string) => {
  const sortByCreatedDate = (a, b) => {
    const dateA = new Date(a.createdOn).getTime();
    const dateB = new Date(b.createdOn).getTime();
    return dateA > dateB ? 1 : -1;
  };
  const sortBySortOrder = (a, b) => (a?.sortOrder < b?.sortOrder ? -1 : 1);
  const sortByComplete = (a, b) => {
    if (a[key] === 'Complete' && b[key] !== 'Complete') {
      return 1;
    } else if (a[key] !== 'Complete' && b[key] === 'Complete') {
      return -1;
    } else {
      return 0;
    }
  };
  return arr
    .sort((a, b) => a?.createdOn && b?.createdOn && sortByCreatedDate(a, b))
    .sort(sortBySortOrder)
    .sort(sortByComplete);
};
